/*
  R9 (2026-08-29) — troca de variante sem perder o lugar na página.

  PROBLEMA (medido no tema cópia, desktop 1440): ao escolher outra cor, o
  media-gallery.js faz `this.replaceWith(newMediaGallery)`. A galeria nova entra sem
  as imagens carregadas, a página encolhe por um instante e o navegador CORTA o scroll
  para o novo fim do documento — o cliente estava em y=900 e era jogado para y=324,
  perdendo de vista o seletor que acabara de usar. Não é reload (o marcador de JS
  sobrevive), é salto de rolagem por mudança de altura.

  SOLUÇÃO, em duas partes:
  1. Guarda a posição no 'variant:update' (fase de captura, antes dos handlers do tema)
     e a devolve a cada quadro por ~1,5s, enquanto a galeria e as imagens assentam.
     Qualquer gesto do cliente (roda, toque, teclado) cancela na hora — nunca brigamos
     com quem quer rolar.
  2. Crossfade curto na galeria durante a troca, para a foto da nova cor aparecer
     suave em vez de piscar. Mesma linguagem do crossfade que o r9-color-rail já usa.

  Sem dependências e sem tocar no JS do tema.
*/
function r9RolarInstantaneo(y) {
  var raiz = document.documentElement;
  var antes = raiz.style.scrollBehavior;
  raiz.style.scrollBehavior = 'auto';
  try {
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
  } catch (e) {
    window.scrollTo(0, y);
  }
  raiz.style.scrollBehavior = antes;
}

(function () {
  var CSS_ID = 'r9-variant-suave-css';
  var QUADROS = 90; // ~1,5s a 60fps
  var FADE_MS = 420;

  function injetarCss() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent =
      '.r9-var-fading media-gallery,.r9-var-fading .product-media-container{' +
      'transition:opacity ' + FADE_MS + 'ms ease;opacity:.42}' +
      '@media (prefers-reduced-motion: reduce){.r9-var-fading media-gallery,' +
      '.r9-var-fading .product-media-container{transition:none;opacity:1}}';
    (document.head || document.documentElement).appendChild(s);
  }

  var travando = false;
  var alvo = 0;
  var quadros = 0;
  var cancelado = false;

  function cancelar() {
    cancelado = true;
  }

  function segurarPosicao() {
    if (cancelado) {
      travando = false;
      return;
    }
    if (Math.abs(window.scrollY - alvo) > 2) {
      r9RolarInstantaneo(alvo);
    }
    quadros += 1;
    if (quadros < QUADROS) {
      requestAnimationFrame(segurarPosicao);
    } else {
      travando = false;
    }
  }

  function armar(ev) {
    injetarCss();

    // --- 1. preserva a posição ---
    alvo = window.scrollY;
    quadros = 0;
    cancelado = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (nome) {
      window.addEventListener(nome, cancelar, { once: true, passive: true });
    });
    if (!travando) {
      travando = true;
      requestAnimationFrame(segurarPosicao);
    }

    // --- 2. crossfade na galeria ---
    var gal = document.querySelector('media-gallery');
    var secao = (ev && ev.target && ev.target.closest && ev.target.closest('.shopify-section')) ||
      (gal && gal.closest('.shopify-section'));
    if (!secao) return;
    secao.classList.add('r9-var-fading');
    setTimeout(function () {
      secao.classList.remove('r9-var-fading');
    }, FADE_MS);
  }

  // O salto acontece ANTES do 'variant:update' (o tema troca a galeria e so depois avisa),
  // entao a posicao precisa ser guardada ja no clique do seletor.
  var SELETORES = 'variant-picker label, variant-picker input, .variant-option__button-label,' +
    ' .r9sw label, .r9sw button, .r9sw__chip, .r9sw__comfort-chip, .r9-color-rail button, .r9-color-rail label';
  document.addEventListener('pointerdown', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest(SELETORES)) armar(ev);
  }, true);
  document.addEventListener('click', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest(SELETORES)) armar(ev);
  }, true);
  // o evento do tema apenas ESTENDE a janela de proteção (nunca redefine o alvo)
  document.addEventListener('variant:update', function () {
    if (travando) { quadros = 0; return; }
  }, true);

  injetarCss();
})();

/*
  ---------------------------------------------------------------------------
  R9 (2026-08-29) — continuidade ao trocar de cor entre PRODUTOS IRMÃOS.

  Na linha Paris (e nas outras que modelam cor como produtos separados), escolher
  outra cor é navegação de verdade: a página nova carrega no TOPO. Medido no tema
  cópia: o cliente estava em y=1400 e caía em y=0 — a queixa de "recarrega e sai da
  minha visão".

  Antes de sair guardamos QUAL bloco o cliente estava usando e a que altura da tela
  ele estava; ao abrir o produto irmão, recolocamos aquele bloco na mesma altura, sem
  animação.

  Dois detalhes que só apareceram medindo:
   - com PRERENDER a página irmã carrega antes do clique, então o DOMContentLoaded
     dela é cedo demais: restauramos na ATIVAÇÃO (prerenderingchange);
   - no mobile o tema remonta o buy-box e o configurador só existe alguns instantes
     depois, então esperamos o bloco aparecer (até 5s) em vez de desistir em 1,2s.
  ---------------------------------------------------------------------------
*/
(function () {
  var CHAVE = 'r9:continuidade';
  var VALIDADE_MS = 30000;
  var ESPERA_BLOCO_MS = 5000;  // ate o bloco existir (mobile monta o buy-box depois)
  var CORRIGE_MS = 2500;       // depois de conseguir posicionar, ainda acompanha o assentamento
  var TETO_MS = 10000;         // limite absoluto: cobre popup/modal que trava a rolagem no mobile
  var ANCORAS = ['.r9sw', '.r9-color-rail', '.r9-ambientes', '.r9-buybox', 'variant-picker'];

  function diag(chave, valor) {
    try {
      if (!window.__r9cont) window.__r9cont = {};
      window.__r9cont[chave] = valor;
    } catch (e) {}
  }

  function seletorDaAncora(el) {
    for (var i = 0; i < ANCORAS.length; i++) {
      if (el.closest(ANCORAS[i])) return ANCORAS[i];
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (ev) {
      var link = ev.target && ev.target.closest && ev.target.closest('a[href*="/products/"]');
      if (!link) return;
      var ancora = seletorDaAncora(link);
      if (!ancora) return;
      var el = document.querySelector(ancora);
      if (!el) return;
      try {
        var dados = { ancora: ancora, topo: Math.round(el.getBoundingClientRect().top), t: Date.now() };
        sessionStorage.setItem(CHAVE, JSON.stringify(dados));
        diag('salvou', dados);
      } catch (e) {}
    },
    true
  );

  function restaurar() {
    var bruto;
    try {
      bruto = sessionStorage.getItem(CHAVE);
      sessionStorage.removeItem(CHAVE);
    } catch (e) {
      return;
    }
    if (!bruto) return;

    var dado;
    try {
      dado = JSON.parse(bruto);
    } catch (e) {
      return;
    }
    if (!dado || Date.now() - dado.t > VALIDADE_MS) return;

    diag('restaurando', dado);

    var inicio = Date.now();
    var primeira = 0;
    var acertos = 0;
    var mexeu = false;
    function cancelar() {
      mexeu = true;
    }
    // 'touchmove' e nao 'touchstart': durante a montagem o proprio tema dispara toques,
    // e cancelar neles fazia a restauracao falhar de forma intermitente no mobile.
    ['wheel', 'touchmove', 'keydown'].forEach(function (n) {
      window.addEventListener(n, cancelar, { passive: true });
    });

    function aplicar() {
      if (mexeu) {
        diag('cancelado', true);
        return;
      }
      var agora = Date.now();
      var el = document.querySelector(dado.ancora);

      if (el) {
        if (!primeira) primeira = agora;
        var destino = Math.max(0, Math.round(el.getBoundingClientRect().top + window.scrollY - dado.topo));
        diag('destino', destino);
        if (Math.abs(window.scrollY - destino) > 4) {
          r9RolarInstantaneo(destino);
          // se a rolagem estiver travada (popup/modal do mobile), o scrollTo nao surte
          // efeito: seguimos tentando ate destravar, dentro do teto.
          if (Math.abs(window.scrollY - destino) > 4) acertos = 0;
        } else {
          acertos += 1;
        }
        if (acertos >= 2 && agora - primeira > CORRIGE_MS) return;
        // segue corrigindo enquanto a pagina assenta: fotos entram depois e, no mobile,
        // o tema remonta o buy-box — qualquer gesto do cliente cancela na hora
        if (agora - inicio < TETO_MS) setTimeout(aplicar, 32);
        return;
      }

      // bloco ainda não montou (no mobile o tema remonta o buy-box): espera aparecer
      if (agora - inicio < ESPERA_BLOCO_MS) setTimeout(aplicar, 16);
      else diag('naoAchou', dado.ancora);
    }
    // setTimeout e nao rAF: um rAF agendado no instante da ativacao do prerender nao chega a rodar
    setTimeout(aplicar, 60);
  }

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', function () { restaurar(); }, { once: true });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restaurar);
  } else {
    restaurar();
  }
})();

/*
  ---------------------------------------------------------------------------
  R9 (2026-08-29) — o configurador (.r9sw) entra no prerender e ganha resposta
  imediata ao toque.

  A Fase 2.5 já tinha colocado o color-rail e a seção Ambientes nas speculation
  rules, mas o configurador de madeira/tecido/cor ficou de fora — era o único
  seletor cuja troca de cor esperava a viagem completa até o servidor. Com o
  prerender, o navegador começa a carregar o produto irmão no hover/toque e o
  clique fica quase instantâneo (medido: TTFB 23ms, DOM em 571ms).

  O retorno visual (chip marcado na hora) existe porque, entre o clique e a
  troca, a página fica ~meio segundo sem sinal nenhum — e meio segundo sem
  resposta é o que faz o cliente clicar de novo.
  ---------------------------------------------------------------------------
*/
(function () {
  var CHIPS = '.r9sw__chip, .r9sw__comfort-chip';
  // chips de cor por VARIANTE (kits/capas, 15/09) apontam para ?variant= da mesma pagina:
  // ficam fora do prerender/prefetch (seriam ate 8 copias da pagina atual), mas
  // recebem o retorno visual imediato abaixo como os demais.
  var CHIPS_PRERENDER = '.r9sw__chip:not(.r9sw__chip--native), .r9sw__comfort-chip';

  // 1. prerender dos irmãos do configurador
  if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    if (!document.getElementById('r9-spec-r9sw')) {
      var spec = document.createElement('script');
      spec.type = 'speculationrules';
      spec.id = 'r9-spec-r9sw';
      spec.textContent = JSON.stringify({
        prerender: [{ source: 'document', where: { selector_matches: CHIPS_PRERENDER }, eagerness: 'moderate' }],
      });
      document.head.appendChild(spec);
    }
  } else {
    // navegadores sem speculation rules: prefetch no hover/toque
    var jaBuscados = {};
    var prefetch = function (ev) {
      var chip = ev.target && ev.target.closest && ev.target.closest(CHIPS_PRERENDER);
      if (!chip) return;
      var url = chip.getAttribute('href');
      if (!url || jaBuscados[url]) return;
      jaBuscados[url] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      document.head.appendChild(l);
    };
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
  }

  // 2. marca o chip escolhido na hora (o servidor confirma logo em seguida)
  document.addEventListener(
    'click',
    function (ev) {
      var chip = ev.target && ev.target.closest && ev.target.closest(CHIPS);
      if (!chip) return;
      var grupo = chip.parentElement;
      if (grupo) {
        grupo.querySelectorAll(CHIPS).forEach(function (c) {
          c.classList.remove('is-selected');
          c.removeAttribute('aria-current');
        });
      }
      chip.classList.add('is-selected');
      chip.setAttribute('aria-current', 'true');
    },
    true
  );
})();
